export const portalSelector = 'body > .atlaskit-portal-container > .atlaskit-portal';
export const portalParentClassName = 'atlaskit-portal-container';
export const portalParentSelector = 'body > .atlaskit-portal-container';
export const portalClassName = 'atlaskit-portal';